import { connect } from 'react-redux'
import SubOrderGroupFooter from './SubOrderGroupFooter'

import onAddItem from './Handlers/onAddItem'
import onDuplicateGroup from './Handlers/onDuplicateGroup'
import onRemoveGroup from './Handlers/onRemoveGroup'

const mapStateToProps = (state) => ({
  editing: state.screens.SubOrder.editing,
  setPercentage: state.screens.SubOrder.subOrder ? state.screens.SubOrder.subOrder.set_percentage : null,
})

const actionCreators = {
  onAddItem,
  onDuplicateGroup,
  onRemoveGroup,
}

export default connect(mapStateToProps, actionCreators)(SubOrderGroupFooter)
